import script from "./ranking-intercept-detail-drawers.vue?vue&type=script&setup=true&lang=ts"
export * from "./ranking-intercept-detail-drawers.vue?vue&type=script&setup=true&lang=ts"

import "./ranking-intercept-detail-drawers.vue?vue&type=style&index=0&id=a50ce462&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a50ce462"]])

export default __exports__